import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { Col } from 'antd';
import { styled } from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var countdownMobileHeight = 105;
export var countDownDesktopHeight = 180;
var TimeColumn = styled(Col)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n"])));
var DisplayNumber = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 20px;\n\n  margin-bottom: 0;\n"])), function (props) {
  var isDisabled = props.isDisabled,
      isCountingDown = props.isCountingDown,
      isAlmostRunOutOfTime = props.isAlmostRunOutOfTime;

  if (isDisabled || !isCountingDown) {
    return styleVariables.colors.gray10;
  }

  return isAlmostRunOutOfTime ? styleVariables.colors.red3 : styleVariables.colors.blue3;
}); // ${(props) => props.theme.media.mobile`
//  font-size: 14px;
// `};

var TimeDescription = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 0;\n  color: ", ";\n  font-size: 14px;\n"])), styleVariables.colors.gray10); // ${(props) => props.theme.media.mobile`
//  font-size: 12px;
// `};

var TimeColumnComponent = function TimeColumnComponent(props) {
  var isDisabled = props.isDisabled,
      isCountingDown = props.isCountingDown,
      isAlmostRunOutOfTime = props.isAlmostRunOutOfTime,
      countdownTime = props.countdownTime,
      label = props.label;
  return /*#__PURE__*/_jsxs(TimeColumn, {
    children: [/*#__PURE__*/_jsx(DisplayNumber, {
      isDisabled: isDisabled,
      isCountingDown: isCountingDown,
      isAlmostRunOutOfTime: isAlmostRunOutOfTime,
      children: countdownTime && parseInt(countdownTime) >= 0 ? countdownTime : 0
    }), /*#__PURE__*/_jsx(TimeDescription, {
      children: label
    })]
  });
};

var formatCountDownTime = function formatCountDownTime(time) {
  var duration = moment.duration(time);
  var totalDays = Math.floor(duration.asDays());
  var totalHours = duration.hours();
  var totalMinutes = duration.minutes();
  var totalSeconds = duration.seconds();
  return {
    countdownDays: totalDays.toString(),
    countdownHours: totalHours.toString(),
    countdownMinutes: totalMinutes.toString(),
    countdownSeconds: totalSeconds.toString()
  };
};

export var CountDownTimer = function CountDownTimer(_ref) {
  var label = _ref.label,
      remainTime = _ref.remainTime,
      isDisabled = _ref.isDisabled,
      onSetElapsedTime = _ref.onSetElapsedTime,
      isCountingDown = _ref.isCountingDown;

  var _useState = useState(remainTime ? remainTime * 1000 : 0),
      elapsedTime = _useState[0],
      setElapsedTime = _useState[1];

  var intervalIdRef = useRef(null);
  useEffect(function () {
    if (isCountingDown) {
      intervalIdRef.current = setInterval(function () {
        setElapsedTime((remainTime ? remainTime - 1 : 0) * 1000);

        if (remainTime >= 0) {
          onSetElapsedTime === null || onSetElapsedTime === void 0 ? void 0 : onSetElapsedTime();
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
      }, 1000);
    } else if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }

    return function () {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, [isCountingDown, onSetElapsedTime, remainTime]);
  var countdownTime = formatCountDownTime(elapsedTime);
  var isAlmostRunOutOfTime = useMemo(function () {
    if (!countdownTime) return false;
    return parseInt(countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownDays) === 0 && parseInt(countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownHours) === 0 && parseInt(countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownMinutes) < 5;
  }, [countdownTime]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TimeColumnComponent, {
      isCountingDown: isCountingDown,
      isAlmostRunOutOfTime: isAlmostRunOutOfTime,
      countdownTime: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownDays,
      label: label.day,
      isDisabled: isDisabled
    }), /*#__PURE__*/_jsx(TimeColumnComponent, {
      isCountingDown: isCountingDown,
      isAlmostRunOutOfTime: isAlmostRunOutOfTime,
      countdownTime: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownHours,
      label: label.hour,
      isDisabled: isDisabled
    }), /*#__PURE__*/_jsx(TimeColumnComponent, {
      isCountingDown: isCountingDown,
      isAlmostRunOutOfTime: isAlmostRunOutOfTime,
      countdownTime: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownMinutes,
      label: label.minute,
      isDisabled: isDisabled
    }), /*#__PURE__*/_jsx(TimeColumnComponent, {
      isCountingDown: isCountingDown,
      isAlmostRunOutOfTime: isAlmostRunOutOfTime,
      countdownTime: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownSeconds,
      label: label.second,
      isDisabled: isDisabled
    })]
  });
};